export const Config = {
  apiUrl: window.location.origin,
  reCAPTCHASiteKey: "6LeaNLAsAAAAAKySN6qyrx-ul2YSCzNjuSUWkReO"//dev & Local
  //reCAPTCHASiteKey: "6LdyTrAsAAAAABusRgY7HHp2ueJx52mdjtZi8lCZ", //prod
};
